import { Box, Button, Container, Typography } from "@mui/material";
import { useSessionContext } from "../../providers/SessionProvider";
import { FC, useState } from "react";
import SessionOverviewGrid from "../../components/sessions/SessionOverviewGrid";
import { usePermissionContext } from "../../providers/PermissionProvider";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useEventContext } from "../../providers/EventProvider";
import { ReSession } from "../../interfaces/types";
import { useCustomThemeContext } from "../../providers/customThemeProvider";

const SessionListPage: FC = () => {
  const navigate = useNavigate();
  const { sessions } = useSessionContext();
  const { updateTheme } = useCustomThemeContext();
  const { events } = useEventContext();
  const { hasSessionOverviewEditPermission, hasPlannerEditPermission } =
    usePermissionContext();
  const [eventSessions, setEventSessions] = useState<ReSession[]>([]);
  const { eventId } = useParams();

  useEffect(() => {
    if (eventId) {
      updateTheme(events?.find((event) => event.id === eventId));
      setEventSessions(
        events
          ?.find((event) => event.id === eventId)
          ?.sessions.map((session) => {
            return sessions?.find((s) => s.id === session) as ReSession;
          }) || []
      );
    }
  }, [eventId, events, sessions]);

  return (
    <Container disableGutters>
      <Typography variant="h4" align="center">
        Session List
      </Typography>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
        {eventId && (
          <Button
            variant="contained"
            onClick={() => navigate(`/event/${eventId}`)}
          >
            Go back to event
          </Button>
        )}
        {eventId && hasPlannerEditPermission(eventId) && (
          <Button
            variant="contained"
            onClick={() => navigate(`/event/planner/${eventId}`)}
          >
            Go to planner
          </Button>
        )}
      </Box>
      <SessionOverviewGrid
        sessions={eventSessions}
        userHasEditPermission={
          eventId ? hasSessionOverviewEditPermission(eventId) : false
        }
      />
    </Container>
  );
};

export default SessionListPage;
